<div class="main-container">
  <form #protocolListForm="ngForm">
    <div class="toolbar-list">

      <div class="toolbar-list-title">
        <div fxLayout="row" fxLayoutAlign="start center">
          <svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="Resource-/-Icon-/-Protocolos" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"
              stroke-linecap="round" stroke-linejoin="round">
              <g id="clipboard" transform="translate(8.000000, 4.000000)" stroke="#00ACC7" class="icon-signature" stroke-width="2">
                <path d="M24,4 L28,4 C30.209139,4 32,5.790861 32,8 L32,36 C32,38.209139 30.209139,40 28,40 L4,40 C1.790861,40 0,38.209139 0,36 L0,8 C0,5.790861 1.790861,4 4,4 L8,4" id="Path"></path>
                <rect id="Rectangle" x="8" y="0" width="16" height="8" rx="2"></rect>
              </g>
            </g>
          </svg>
          <h1 class="accent-color">{{ 'signatureBox.title' | translate }}</h1>
        </div>

        <div class="breadcrumbs">
          <a href="#">{{ 'common.start.label' | translate }}</a> / <span>{{ 'signatureBox.title' | translate }}</span>
        </div>
      </div>

      <div class="toolbar-back-button">
        <a (click)="cancel()" mat-button color="secondary">
          <mat-icon color="secondary">undo</mat-icon> {{ 'button.back' | translate }}
        </a>
      </div>
    </div>

    <app-signature-box-filter #filterComponent (filterEmitter)="doFilter($event)" class="filter-container">
    </app-signature-box-filter>

    <div class="table-container">
      <table #protocols mat-table matSort [dataSource]="dataSource">

        <!-- client Column -->
        <ng-container matColumnDef="documentCode">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'signatureBoxList.cols.nDocument' | translate }}
          </th>
          <td mat-cell *matCellDef="let item" [ngStyle]="{'color': getColorStatus(item.idStatus)}"> {{ item.documentCode
          }} </td>
        </ng-container>

        <!-- modFc Column -->
        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'signatureBoxList.cols.idType' | translate }} </th>
          <td mat-cell *matCellDef="let item" [ngStyle]="{'color': getColorStatus(item.idStatus)}"> {{
          getTypeDocument(item.idType) }} </td>
        </ng-container>

        <!-- modFc Column -->
        <ng-container matColumnDef="client">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'signatureBoxList.cols.client' | translate }} </th>
          <td mat-cell *matCellDef="let item" [ngStyle]="{'color': getColorStatus(item.idStatus)}"> {{ item.nameClient
          }} </td>
        </ng-container>

        <!-- projectNo Column -->
        <ng-container matColumnDef="fullName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'signatureBoxList.cols.user' | translate }} </th>
          <td mat-cell *matCellDef="let item" [ngStyle]="{'color': getColorStatus(item.idStatus)}"> {{ item.fullName !=
          null ? item.fullName : '-'}} </td>
        </ng-container>

        <!-- status Column -->
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'signatureBoxList.cols.status' | translate }} </th>
          <td mat-cell *matCellDef="let item" [ngStyle]="{'color': getColorStatus(item.idStatus)}"> {{ item.nameStatus
          != null ? item.nameStatus: '-'}} </td>
        </ng-container>

        <!-- modFc Column -->
        <ng-container matColumnDef="countUser">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'signatureBoxList.cols.countUser' | translate }}
          </th>
          <td mat-cell *matCellDef="let item" [ngStyle]="{'color': getColorStatus(item.idStatus)}"> {{ item.countUser }}
          </td>
        </ng-container>

        <!-- regUser Column -->
        <ng-container matColumnDef="regDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'signatureBoxList.cols.regDate' | translate }} </th>
          <td mat-cell *matCellDef="let item" [ngStyle]="{'color': getColorStatus(item.idStatus)}"> {{ item.regDate |
          fixDate }} </td>
        </ng-container>

        <!-- Button edit Column -->
        <ng-container matColumnDef="edit">
          <th mat-header-cell *matHeaderCellDef [ngStyle]="{'display': 'none'}"></th>
          <td mat-cell *matCellDef="let element" fxHide.lt-lg class="action">
            <button mat-icon-button (click)="openDialogSigner(element)" matTooltip="{{ 'button.edit' | translate }}">
              <mat-icon>mode_edit</mat-icon>
            </button>
          </td>
        </ng-container>
        <ng-container matColumnDef="download">
          <th mat-header-cell *matHeaderCellDef [ngStyle]="{'display': 'none'}"></th>
          <td mat-cell *matCellDef="let element" fxHide.lt-lg class="action">
            <button mat-button (click)="downloadPdf(element)">
              <mat-icon>cloud_download</mat-icon> {{ 'button.download' | translate }}
            </button>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

      </table>

      @if (!hasFiltered) {
        <span class="prefilterMessage">
          <p [innerHtml]="'common.listPlaceholder' | translate | safe: 'html'"> </p>
        </span>
      }

    </div>

    <div class="table-footer-container">
      <div class="paginator">
        <mat-paginator [pageSize]="5" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons
          [length]="dataSource?.totalItems$ | async" (page)="loadSignatureBox()" lang="es">
        </mat-paginator>
      </div>
    </div>
  </form>
</div>